import { TrackingCallback } from '@growthbook/growthbook-react';
import { getGrowthBookDeviceId } from './cookies';

/**
 * Tracking callback for GrowthBook experiment exposures.
 * Sends "Experiment Viewed" events to RudderStack with the same format as the marketing site.
 *
 * Event properties match marketing site for consistent attribution:
 * - experiment_id, variation_id: identify the experiment and variant
 * - hash_attribute, hash_value: what attribute was used for bucketing (should be 'id')
 * - gb_device_id: explicit device ID for easy joining with Order Completed events
 */
export const createTrackingCallback = (): TrackingCallback => {
  return (experiment, result) => {
    const deviceId = getGrowthBookDeviceId();

    // Only track if we have at least a device ID
    if (!deviceId) {
      // eslint-disable-next-line no-console
      console.warn('[GrowthBook] Cannot track experiment exposure: no gb_device_id cookie found');
      return;
    }

    window.rudderanalytics?.track?.('Experiment Viewed', {
      experiment_id: experiment.key,
      variation_id: result.key,
      in_experiment: result.inExperiment,
      hash_used: result.hashUsed,
      hash_attribute: result.hashAttribute,
      hash_value: result.hashValue,
      // Explicit gb_device_id for attribution - allows easy joining with Order Completed events
      gb_device_id: deviceId,
    });
  };
};
